import { render, staticRenderFns } from "./datatablepaging.vue?vue&type=template&id=6d286b5a&scoped=true&"
import script from "./datatablepaging.vue?vue&type=script&lang=js&"
export * from "./datatablepaging.vue?vue&type=script&lang=js&"
import style0 from "./datatablepaging.vue?vue&type=style&index=0&id=6d286b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d286b5a",
  null
  
)

export default component.exports